export default __webpack_public_path__ + "img/eye.f168efa3.svg";